import { render, staticRenderFns } from "./escalation_policy_collapsed_state.vue?vue&type=template&id=5fef5902"
import script from "./escalation_policy_collapsed_state.vue?vue&type=script&lang=js"
export * from "./escalation_policy_collapsed_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports